"use client";

import { FC } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/common/components/ui/button";
import { cn } from "@/common/utils/cn";
import { ArrowRightIcon } from "./icons";
interface BackButtonProps {
  className?: string;
  callbackUrl?: string;
  arrowClassName?: string;
}
export const BackButton: FC<BackButtonProps> = props => {
  const {
    callbackUrl,
    className,
    arrowClassName
  } = props;
  const router = useRouter();
  function handleBackButton() {
    if (callbackUrl) {
      router.push(callbackUrl);
      return;
    }
    router.back();
  }
  return <Button onClick={handleBackButton} size="icon-sm" variant="text" rounded="full" color="gray" className={cn("fill-gray hover:fill-gray", className)} data-sentry-element="Button" data-sentry-component="BackButton" data-sentry-source-file="BackButton.tsx">
      <ArrowRightIcon className={cn("size-6 text-black", arrowClassName)} data-sentry-element="ArrowRightIcon" data-sentry-source-file="BackButton.tsx" />
    </Button>;
};